import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { reportHistory } from "../services/reportHistory";

export function useReportHistory() {
  return useQuery({
    queryKey: ["reportHistory"],
    queryFn: () => reportHistory.getAll(),
    staleTime: 0, // Always fetch fresh
  });
}

export function useReportById(id) {
  return useQuery({
    queryKey: ["report", id],
    queryFn: () => reportHistory.get(id),
    enabled: !!id,
  });
}

export function useClearHistory() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: () => {
      reportHistory.clear();
      return Promise.resolve();
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["reportHistory"] });
      queryClient.invalidateQueries({ queryKey: ["report"] });
    },
  });
}

export function useDeleteReport() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (id) => {
      reportHistory.remove(id);
      return Promise.resolve(id);
    },
    onSuccess: (id) => {
      queryClient.invalidateQueries({ queryKey: ["reportHistory"] });
      queryClient.invalidateQueries({ queryKey: ["report", id] });
    },
  });
}

export function useUpdateReport() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ id, updates }) => {
      reportHistory.update(id, updates);
      return reportHistory.get(id);
    },
    onSuccess: (updated) => {
      if (updated) {
        queryClient.invalidateQueries({ queryKey: ["reportHistory"] });
        queryClient.invalidateQueries({ queryKey: ["report", updated.id] });
      }
    },
  });
}

export function useAddReport() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (report) => {
      reportHistory.add(report);
      return Promise.resolve(report);
    },
    onSuccess: (report) => {
      queryClient.invalidateQueries({ queryKey: ["reportHistory"] });
      queryClient.invalidateQueries({ queryKey: ["report", report.id] });
    },
  });
}
